import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import Layout from './components/layout/Layout';
import AuditLogs from './components/AuditLogs/AuditLogs';
import PurchaseOrderContainer from './containers/PurchaseOrder/PurchaseOrderContainer';
import Login from './components/auth/Login';
import Signup from './components/auth/Signup';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import EmailVerification from './components/auth/EmailVerification';
import UserProfile from './components/auth/UserProfile';
import ProtectedRoute from './components/auth/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import store from './redux/store';
import ProductList from './components/Product/ProductList';
import ProductForm from './components/Product/ProductForm';
import VendorList from './components/Vendor/VendorList';
import VendorForm from './components/Vendor/VendorForm';
import SiteConfigurations from './components/SiteConfigurations/SiteConfigurations';
import RBAC from './components/RBAC/RBAC';
import Home from './components/Home/Home';
import Dashboard from './components/Dashboard/Dashboard';
import DeliveryChallan from './components/DeliveryChallan/DeliveryChallan';
import BillReceipt from './components/BillReceipt/BillReceipt';
import Analytics from './components/Analytics/Analytics';
import Payment from './components/Payment/Payment';
import VendorPerformance from './components/Vendor/VendorPerformance';
import ApprovalInbox from './components/Approval/ApprovalInbox';
import PriceInflationReport from './components/Product/PriceInflationReport';
import QuotationList from './components/Quotation/QuotationList';
import ReturnOrderList from './components/Returns/ReturnOrderList';
import RecurringPOList from './components/Admin/RecurringPOList';
import MonthComparison from './components/Analytics/MonthComparison';
import 'antd/dist/reset.css';
import './App.css';

function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<EmailVerification />} />

            {/* Protected Routes - Wrapped with Layout */}

            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/purchase-order" element={
              <ProtectedRoute>
                <Layout>
                  <PurchaseOrderContainer />
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/products" element={
              <ProtectedRoute>
                <Layout>
                  <ProductList />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/products/add" element={
              <ProtectedRoute>
                <Layout>
                  <ProductForm />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/products/edit/:id" element={
              <ProtectedRoute>
                <Layout>
                  <ProductForm />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/vendors" element={
              <ProtectedRoute>
                <Layout>
                  <VendorList />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/vendors/add" element={
              <ProtectedRoute>
                <Layout>
                  <VendorForm />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/vendors/edit/:id" element={
              <ProtectedRoute>
                <Layout>
                  <VendorForm />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/audit-logs" element={
              <ProtectedRoute>
                <Layout>
                  <AuditLogs />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/site-configurations" element={
              <ProtectedRoute>
                <Layout>
                  <SiteConfigurations />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/rbac" element={
              <ProtectedRoute>
                <Layout>
                  <RBAC />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/profile" element={
              <ProtectedRoute>
                <Layout>
                  <UserProfile />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/delivery-challans" element={
              <ProtectedRoute>
                <Layout>
                  <DeliveryChallan />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/bill-receipts" element={
              <ProtectedRoute>
                <Layout>
                  <BillReceipt />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/analytics" element={
              <ProtectedRoute>
                <Layout>
                  <Analytics />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/payments" element={
              <ProtectedRoute>
                <Layout>
                  <Payment />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/vendor-performance" element={
              <ProtectedRoute>
                <Layout>
                  <VendorPerformance />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/approvals" element={
              <ProtectedRoute>
                <Layout>
                  <ApprovalInbox />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/price-inflation" element={
              <ProtectedRoute>
                <Layout>
                  <PriceInflationReport />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/quotations" element={
              <ProtectedRoute>
                <Layout>
                  <QuotationList />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/returns" element={
              <ProtectedRoute>
                <Layout>
                  <ReturnOrderList />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/recurring-pos" element={
              <ProtectedRoute>
                <Layout>
                  <RecurringPOList />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/analytics/month-comparison" element={
              <ProtectedRoute>
                <Layout>
                  <MonthComparison />
                </Layout>
              </ProtectedRoute>
            } />

          </Routes>
        </Router>
      </AuthProvider>
    </Provider>
  );
}

export default App;
